module.exports = __webpack_public_path__ + "img/2_42.592537ef.png";